module.exports = __webpack_public_path__ + "media/images/shared/popup_about/renewal-71006c0684f8f2ed799ff3dff2b535b5.png";